(function (root) {
  'use strict';
  const normal = (text) => String(text || '').trim().toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' ');
  function classify(composition) {
    const labels = String(composition || '').trim().split(/\s+&\s+/);
    if (labels.length !== 2) return [];
    const metal = normal(labels[0]);
    const gem = normal(labels[1]);
    const gemKeys = { 'lab-grown sapphire': 'sapphire', 'lab grown sapphire': 'sapphire', 'lab-grown spinel': 'spinel', 'lab grown spinel': 'spinel', moissanite: 'moissanite', 'lab-grown moissanite': 'moissanite', yag: 'yag', 'lab-grown yag': 'yag', 'lab grown yag': 'yag', 'yttrium aluminium garnet': 'yag', 'yttrium aluminum garnet': 'yag' };
    const metalKeys = { 'sterling silver': 'silver', '925 sterling silver': 'silver', '14k gold vermeil': 'vermeil', 'gold vermeil': 'vermeil' };
    return [gemKeys[gem], metalKeys[metal]].filter(Boolean);
  }
  function resolveProductInfo(element) {
    const productId = String(element.dataset?.productId || '');
    if (!/^\d+$/.test(productId)) return null;
    const candidates = Array.from(element.ownerDocument?.querySelectorAll('product-info[id^="MainProduct-"][data-product-id][data-update-url="true"]') || [])
      .filter((candidate) => candidate.dataset.productId === productId);
    return candidates.length === 1 ? candidates[0] : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { classify, resolveProductInfo };
  if (!root.customElements || root.customElements.get('alvaura-material-education')) return;

  class AlvauraMaterialEducation extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.hidden = true;
      this.cards = this.querySelector('[data-education-cards]');
      if (!this.cards) return;
      this.update = () => {
        if (!this.composition || !this.availability) {
          this.hidden = true;
          return;
        }
        const ready = this.availability.hasAttribute('data-ready');
        const state = this.availability.dataset.state;
        const keys = ready && !['pending', 'unavailable'].includes(state) ? classify(this.composition.textContent) : [];
        const identity = keys.join('|');
        if (identity !== this.identity) {
          this.identity = identity;
          this.cards.replaceChildren();
          keys.forEach((key) => {
            const template = this.querySelector(`template[data-education-key="${key}"]`);
            if (template?.content) this.cards.append(template.content.cloneNode(true));
          });
        }
        this.cards.querySelectorAll('[data-education-gold-only]').forEach((row) => {
          row.hidden = !(keys.includes('sapphire') && keys.includes('vermeil'));
        });
        this.hidden = keys.length === 0 || !this.cards.children.length;
      };
      this.handleSourceEvent = (event) => {
        if (event.type === 'shopify:section:unload') {
          if (event.target?.contains?.(this.productInfo)) this.clearSource();
          return;
        }
        this.bindSource();
      };
      this.sourceDocument = this.ownerDocument;
      for (const name of ['product-info:loaded', 'shopify:section:load', 'shopify:section:unload']) {
        this.sourceDocument?.addEventListener(name, this.handleSourceEvent);
      }
      this.bindSource();
    }
    bindSource() {
      const productInfo = resolveProductInfo(this);
      const composition = productInfo?.querySelector('[data-alvaura-composition]');
      const availability = productInfo?.querySelector('alvaura-availability');
      if (productInfo === this.productInfo && composition === this.composition && availability === this.availability) {
        if (composition && availability) this.update();
        return;
      }
      this.clearSource();
      if (!composition || !availability) return;
      this.productInfo = productInfo;
      this.composition = composition;
      this.availability = availability;
      this.compositionObserver = new MutationObserver(this.update);
      this.compositionObserver.observe(this.composition, { childList: true, characterData: true, subtree: true });
      this.stateObserver = new MutationObserver(this.update);
      this.stateObserver.observe(this.availability, { attributes: true, attributeFilter: ['data-state', 'data-ready'] });
      this.update();
    }
    clearSource() {
      this.compositionObserver?.disconnect();
      this.stateObserver?.disconnect();
      this.compositionObserver = null;
      this.stateObserver = null;
      this.productInfo = null;
      this.composition = null;
      this.availability = null;
      this.identity = null;
      this.hidden = true;
      this.cards?.replaceChildren();
    }
    disconnectedCallback() {
      this.clearSource();
      for (const name of ['product-info:loaded', 'shopify:section:load', 'shopify:section:unload']) {
        if (this.handleSourceEvent) this.sourceDocument?.removeEventListener(name, this.handleSourceEvent);
      }
      this.handleSourceEvent = null;
      this.sourceDocument = null;
    }
  }
  root.customElements.define('alvaura-material-education', AlvauraMaterialEducation);
})(typeof window === 'undefined' ? globalThis : window);
